import * as React from 'react';
import {
    bidderPreferenceLoadingSelector,
    bidderPreferenceSelector,
    fetchBidderPreferencesIfNeeded,
    updateBidderPreferences,
} from '@/redux/modules/bidderPreference';
import { useDispatch, useSelector } from 'react-redux';
import Button from '@liveauctioneers/caterwaul-components/lib/Button/Button';
import { FormattedMessage } from 'react-intl';
import Radio from '@liveauctioneers/caterwaul-components/lib/Radio/Radio';
import Radios from '@liveauctioneers/caterwaul-components/lib/Radio/Radios';
import styled from 'styled-components';

type Props = {
    className?: string;
};

const CurrencySelection = ({ className }: Props) => {
    const dispatch = useDispatch();
    const bidderPreferences = useSelector(bidderPreferenceSelector);
    const bidderPreferenceLoading = useSelector(bidderPreferenceLoadingSelector);
    const [selectedCurrency, setSelectedCurrency] = React.useState(bidderPreferences.preferredCurrency);

    const onChange = React.useCallback((event) => {
        setSelectedCurrency(event.currentTarget.name);
    }, []);

    const onSave = React.useCallback(() => {
        dispatch(
            updateBidderPreferences({
                ...bidderPreferences,
                preferredCurrency: selectedCurrency,
            })
        );
    }, [dispatch, bidderPreferences, selectedCurrency]);

    React.useEffect(() => {
        setSelectedCurrency(bidderPreferences.preferredCurrency);
    }, [bidderPreferences]);

    React.useEffect(() => {
        dispatch(fetchBidderPreferencesIfNeeded());
    });

    return (
        <StyledCurrencySelection className={className}>
            <Radios onChange={onChange} selectedName={selectedCurrency}>
                <StyledRadio label="GBP" name="GBP" />
                <StyledRadio label="EURO" name="EUR" />
                <StyledRadio label="USD" name="USD" />
                <StyledRadio label={<FormattedMessage id="preferredCurrencyConversion.noConversion" />} name="N/A" />
            </Radios>
            <StyledSaveButton loading={bidderPreferenceLoading} onClick={onSave}>
                <FormattedMessage id="preferredCurrencyConversion.save" />
            </StyledSaveButton>
        </StyledCurrencySelection>
    );
};

export default CurrencySelection;

const StyledCurrencySelection = styled.div`
    max-width: 250px;
`;

const StyledRadio = styled(Radio)`
    margin-top: 10px;
    padding-bottom: 10px;
    border-bottom: 1px solid ${({ theme }) => theme.colors.grey700};
`;

const StyledSaveButton = styled(Button)`
    margin-top: 20px;
    width: 150px;
`;
